export default __webpack_public_path__ + "static/media/resume.98460bee.docx";